export default __webpack_public_path__ + "static/media/Aircraft2-t.d8244961.png";